<template>
    <div>
        <div class="col-md-12">
            <br />
            <form  @submit.prevent="searchData()" role="form">
                <div class="row">
                    <div class="col-2">

                        <input type="text"
                               class="form-control"
                               v-model="pagingInfo.search"
                               placeholder="Serial No" />

                    </div>
                    <div class="col-2">

                        <select id="region"
                                class="form-control"
                                v-model="pagingInfo.mydata">
                            <option value="0">All Data</option>
                            <option value="1">My Encodes</option>
                        </select>

                    </div>
                    <div class="col-2">

                        <button type="submit" class="btn btn-info ">
                            <strong>Search</strong>
                        </button>&nbsp;
                        <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>

                    </div>
                </div>
                

            </form>
            <br />

            <div class="box">
                <div class="box-header"></div>
                <div class="box-body table-responsive no-padding">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <!--<th>ID</th>-->
                                <th>Serial No</th>
                                <th>Make</th>
                                <th>Caliber</th>
                                <th>Model</th>
                                <th>Comments</th>
                                <th>Created By</th>
                                <th>
                                    Date Created
                                </th>
                                <th>Updated By</th>
                                <th>
                                    Date Updated
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="doc in docs" v-bind:key="doc.id">
                                <td>{{ doc.serialNo | capitalize }}</td>
                                <td>{{ doc.make }}</td>
                                <td>{{ doc.caliber }}</td>
                                <td>{{ doc.model }}</td>
                                <td>{{ doc.comments }}</td>
                                <td>{{ doc.createdBy }}</td>
                                <td>{{ doc.dateCreated | formatDate }}</td>
                                <td>{{ doc.updatedBy }}</td>
                                <td>{{ doc.dateUpdated | formatDate }}</td>
                                <td v-if="$store.getters.LINKMODE">
                                    <button class="btn btn-sm btn-success"
                                            @click="setLink(doc.id)">
                                        Link Object
                                    </button>
                                </td>
                                <td v-else-if="$store.getters.CRAD">
                                    <TheDropDownButton>
                                        <btn @click.native="editFireArm(doc.id)"
                                             icon="fa fa-pencil-alt"
                                             title="Edit"></btn>&nbsp;
                                        <btn @click.native="More(doc)"
                                             icon="fa fa-expand-alt"
                                             title="View Linkages"></btn>
                                        <btn @click.native="requestlinkdownload(doc.id)"
                                             icon="fa fa-cloud-download-alt"
                                             title="Export"></btn>
                                        <btn @click.native="addtoMerge(doc)"
                                             icon="fa fa-code-branch"
                                             title="Merge Record"></btn>
                                    </TheDropDownButton>
                                </td>
                                <td v-else-if="$store.getters.VIEWER">
                                    <TheDropDownButton>
                                        <btn @click.native="More(doc)"
                                             icon="fa fa-expand-alt"
                                             title="View Linkages"></btn>
                                    </TheDropDownButton>
                                </td>
                                <td v-else>
                                    <TheDropDownButton>
                                        <btn v-if="mydata"
                                             @click.native="editFireArm(doc.id)"
                                             icon="fa fa-pencil-alt"
                                             title="Edit"></btn>&nbsp;
                                        <btn @click.native="More(doc)"
                                             icon="fa fa-expand-alt"
                                             title="View Linkages"></btn>
                                    </TheDropDownButton>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot></tfoot>
                    </table>
                    <div v-show="totalitems == 0" class="alert alert-warning">
                        <p>Found no result try again</p>
                    </div>
                </div>
            </div>

            <b-pagination v-model="pagingInfo.page"
                          v-on:input="fetchData()"
                          :total-rows="totalitems"
                          :per-page="pagingInfo.itemsPerPage"
                          first-text="First"
                          prev-text="Prev"
                          next-text="Next"
                          last-text="Last"></b-pagination>
        </div>
        <div>
            <b-modal id="LinkPopupFA" title="Link Builder" scrollable hide-footer>
                <LinkPopUp />
            </b-modal>
            <b-modal id="EditPopUPFA"
                     title="Edit FireArms"
                     size="lg"
                     scrollable
                     hide-footer>
                <FirArmEdit v-bind:id="FireArmId"
                            v-on:done-edit-firearms="doneEdit()" />
            </b-modal>

            <b-modal id="linkpopupfa" size="xl" scrollable hide-footer>
                <LinkComponentPopFA v-bind:id="linkid"
                                    v-bind:linkdescription="linkdescription" />
            </b-modal>
            <b-modal id="mergerecordfa"
                     size="md"
                     hide-footer
                     ref="merger"
                     no-close-on-esc="true"
                     no-close-on-backdrop="true"
                     hide-header-close="true">
                <MergePopUpfa v-bind:obj1ID="obj1Id"
                            v-bind:obj2ID="obj2Id"
                            v-bind:obj1Desc="obj1description"
                            v-bind:obj2Desc="obj2description"
                            v-bind:objType="objType"
                            v-on:done="done()"
                            v-on:cancel="cancel()" />
            </b-modal>
        </div>
    </div>
</template>
<script>

    import {
        authHeader,
        responseCheck,
        RecordURL,
        setObject2Link,
        RequestLink,
        notifyHelper
    } from "../helper";
    import LinkPopUp from "./master/Linking";
    import FirArmEdit from "./edit/FireArm";
    import btn from "./buttons/iconButton";
    import LinkComponentPopFA from "./link/linkcomponent";
    import MergePopUpfa from "./master/recordMerge";
    import instance from '../helper/http'
    export default {
        data() {
            return {
                docs: [],
                pagingInfo: {
                    page: 1,
                    search: "",
                    sortBy: "Make",
                    reverse: false,
                    mydata: 0,
                },
                totalitems: null,
                FireArmId: "",
                mydata: false,
                linkid: "",
                linkdescription: "",
                obj1Id: "",
                obj2Id: "",
                objType: "",
                obj1description: "",
                obj2description: "",
                hasfirst: false,
            };
        },
        components: {
            LinkPopUp,
            FirArmEdit,
            btn,
            LinkComponentPopFA,
            MergePopUpfa
        },
        methods: {
            async requestlinkdownload(id) {
                await RequestLink(id);
            },
            clearControls() {
                this.pagingInfo.search = "";
            },
            fetchData() {
                if (this.pagingInfo.mydata == "0") this.mydata = false;
                else this.mydata = true;

                instance
                    .get(RecordURL + "getfirearms", {
                        headers: authHeader(),
                        params: this.pagingInfo,
                    })
                    .then((response) => {
                        this.docs = response.data.data;
                        this.totalitems = response.data.count;

                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                        this.docs = [];
                        this.mydata = false
                    })

            },
            addtoMerge(data) {
                var additional =
                    (data.serialNo ? data.serialNo : "") +
                    " " +
                    (data.make ? data.make : "") +
                    " " +
                    (data.caliber ? data.caliber : "");
                additional = additional.replace(/\//g, "-");
                if (this.hasfirst) {
                    if (this.obj1Id == data.id) {
                        notifyHelper("info", "Cannot merge the same firearm");
                    }
                    else {
                        this.obj2description = additional;
                        this.obj2Id = data.id;
                        this.objType = "FA"
                        //open the popup
                        this.$bvModal.show("mergerecordfa");
                    }

                } else {
                    this.obj1description = additional;
                    this.obj1Id = data.id;
                    this.hasfirst = true;
                    notifyHelper(
                        "success",
                        "Add to merging of record, please choose another record to merge"
                    );
                }
            },
            cancel() {
                this.$bvModal.hide("mergerecordfa");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
            },
            done() {
                this.$bvModal.hide("mergerecordfa");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
                this.fetchData();
            },
            searchData() {
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            More: function (data) {
                var additional1 = (data.serialNo ? data.serialNo : '') + " " + (data.make ? data.make : '')
                if (data.serialNo !== null) {
                    additional1 = additional1.replace(/\//g, "-");
                }
                else {
                    additional1 = "Serial No. not available"
                }

                this.linkid = data.id;
                this.linkdescription = additional1;
                this.$bvModal.show("linkpopupfa");
            },
            sort: function (sortBy) {
                if (sortBy === this.pagingInfo.sortBy) {
                    this.pagingInfo.reverse = !this.pagingInfo.reverse;
                } else {
                    this.pagingInfo.sortBy = sortBy;
                    this.pagingInfo.reverse = false;
                }
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            setLink: function (id) {
                setObject2Link(id, "FA");
                this.$bvModal.show("LinkPopupFA");
            },
            editFireArm: function (id) {
                this.FireArmId = id;
                //modal
                this.$bvModal.show("EditPopUPFA");
            },
            doneEdit() {
                this.$bvModal.hide("EditPopUPFA");
            },
        },
    };
</script>